
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/privacy",
      function () {
        return require("private-next-pages/[locale]/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/privacy"])
      });
    }
  